export const PAINT_PURCHASE_HISTORY_LINK = "/myaccount/paintPurchaseHistory";
